<template>
    <div class="text">
        <label class="required">
            S<sub><small>DS</small></sub>
        </label>
        <input
            type="number"
            key="sds-input"
            :value="value"
            v-on:change="$emit('change', $event.target.value)"
            placeholder="Enter your SDS value"  
            class="sds-input"
            min="0" 
            max="4" 
            step=".1" 
            required 
        />
        <p class="error simple" v-if="error" v-html="error"></p>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {type: [String, Number]},
        error: {type: [String]},
    },
}
</script>